module.exports = __webpack_public_path__ + "img/map-wcy.d4874aaf.png";